import { gql } from '@apollo/client';
import { INTEGRATION_META_TYPE_FIELDS } from '@/graphql/fragments/integration_meta_types';
import { INTEGRATION_META_PRICING_OVERRIDES_FIELDS } from '@/graphql/fragments/integration_meta_pricing_overrides';
import { INTEGRATION_META_CARRIER_PRICING_OVERRIDES_FIELDS } from '@/graphql/fragments/integration_meta_carrier_pricing_overrides';
import { INTEGRATION_META_INTEGRATION_OVERRIDES_FIELDS } from '@/graphql/fragments/integration_meta_integration_overrides';

export const GET_PRICING_OVERRIDES_OPTIONS = gql`
    ${INTEGRATION_META_TYPE_FIELDS}
    ${INTEGRATION_META_PRICING_OVERRIDES_FIELDS}
    ${INTEGRATION_META_CARRIER_PRICING_OVERRIDES_FIELDS}
    ${INTEGRATION_META_INTEGRATION_OVERRIDES_FIELDS}

    query GetPricingOverrideOptions {
        results: integration_meta_types {
            ...IntegrationMetaTypeFields

            pricing_overrides {
                ...IntegrationMetaPricingOverridesFields
            }

            carrier_pricing_overrides {
                ...IntegrationMetaCarrierPricingOverridesFields
            }

            integration_overrides {
                ...IntegrationMetaIntegrationOverridesFields

                carrier {
                    client_id
                    business_name
                    email
                    locations {
                        location_id
                        location_name
                        business_zip
                    }
                }

                middle_mile_carrier {
                    client_id
                    business_name
                    email
                    locations {
                        location_id
                        location_name
                        business_zip
                    }
                }
            }
        }
    }
`;
